import { object, date, boolean } from "yup";
import getPartialValidationSchemaAdmin from "./partial-validation-schema-admin";

export default ({ intl, startDate, hasAdminPrivileges }) => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });
  const notADate = intl.formatMessage({ id: "app.form.notadate" });
  const endDateNotBeforeStartDate = intl.formatMessage({ id: "app.form.endDateNotBeforeStartDate" });

  return object().shape({
    endDate: date()
      .required(requiredText)
      .typeError(notADate)
      .min(startDate || new Date(), endDateNotBeforeStartDate),
    visible: boolean().required(requiredText),
    billable: boolean().required(requiredText),
    isInternalTest: boolean(),
    ...getPartialValidationSchemaAdmin({ intl, hasAdminPrivileges }),
  });
};
